export const Colors = {
  primary: "#31BF2C",
  secondary: "#70D96C",
  accent: "##F2B807",
  dark: "#0D0D0D",
  gray: "#D7D9D9",
  light: "#F2F2F2",
  white: "#ffffff",
};
